import { render } from "./OrderEditContainerDetailsModal.vue?vue&type=template&id=8ef6a310&ts=true"
import script from "./OrderEditContainerDetailsModal.vue?vue&type=script&lang=ts"
export * from "./OrderEditContainerDetailsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__